import { render, staticRenderFns } from "./AgreementsUpdate.vue?vue&type=template&id=28d11abe&scoped=true&"
import script from "./AgreementsUpdate.vue?vue&type=script&lang=js&"
export * from "./AgreementsUpdate.vue?vue&type=script&lang=js&"
import style0 from "./AgreementsUpdate.vue?vue&type=style&index=0&id=28d11abe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28d11abe",
  null
  
)

export default component.exports